export default __webpack_public_path__ + "static/media/video_call.d7768a44.png";